import HttpStatus from 'components/Common/HttpStatus'
import Error404Page from 'components/Pages/Error404Page'
import loadable from '@loadable/component'
import { Route, Routes, useLocation } from 'react-router-dom'
import { REGIONLESS_DIRECT_ROUTE_PATHS } from 'lib/routing/regionlessPageRoutes'
import { useMemo } from 'react'
import { LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP, LE_AGENT_HUB_SOCIETE_CONFIRMATION } from './AgentHubRoutes'
import AuthRouteComponent from 'components/App/Routes/AuthRouteComponent'
import UrlLocation from 'src/lib/url/UrlLocation'
import config from 'constants/config'

const AgentHubLandingPage = loadable(() => import('agentHub/pages/landing/AgentHubLandingPage'))
const AgentHubCompleteAccountSetup = loadable(() => import('agentHub/pages/AgentHubAccountSetup/AgentHubCompleteAccountSetupPage'))
const SocieteConfirmationPage = loadable(() => import('agentHub/pages/SocieteConfirmationPage'))
const ResetPasswordPage = loadable(() => import('components/Pages/ResetPasswordPage/ResetPasswordPage'))
const AgentHubOidcCallback = loadable(() => import('agentHub/pages/AgentHubOidcCallback'))
const SecurePaymentPage = loadable(() => import('components/Pages/SecurePaymentPage'))

function AgentHubAuthWall() {
  return <AuthRouteComponent match={null} showPopup />
}

function AgentHubNotFound() {
  return <HttpStatus code={404}>
    <Error404Page />
  </HttpStatus>
}

function AgentHubGuestPageRoutes() {
  const location = useLocation()
  const localeStrippedLocation = useMemo(() => {
    return {
      ...location,
      pathname: new UrlLocation(location.pathname).withoutLocale().path,
    }
  }, [location])

  return <Routes location={localeStrippedLocation}>
    {/* Auth V2 (OIDC) redirect target. Region-less: svc-auth allowlists the
        exact `${origin}/oidc-callback` redirect_uri. The region-prefixed variant
        is insurance in case a region redirect rewrites the path before this
        router sees it. A static segment outranks the dynamic `/:regionCode`. */}
    <Route path={REGIONLESS_DIRECT_ROUTE_PATHS[0]} element={<AgentHubOidcCallback />} />
    <Route path="/:regionCode/oidc-callback" element={<AgentHubOidcCallback />} />
    <Route path="/:regionCode" element={<AgentHubLandingPage />} />
    <Route path={`/:regionCode${LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP}`} element={<AgentHubCompleteAccountSetup />} />
    <Route path={`/:regionCode${LE_AGENT_HUB_SOCIETE_CONFIRMATION}`} element={<SocieteConfirmationPage />} />
    <Route path="/:regionCode/reset-password/:resetPasswordToken" element={<ResetPasswordPage />} />
    {config.SECURE_PAYMENT_ENABLED && <Route path="/:regionCode/pay/:paymentLinkId" element={<SecurePaymentPage />} />}
    <Route path="/:regionCode/*" element={<AgentHubAuthWall />} />
    <Route path="*" element={<AgentHubNotFound />} />
  </Routes>
}

export default AgentHubGuestPageRoutes
